<script lang="ts">
    import { getI18n } from '~/stores/i18n';
    import { getJetPerform } from '~/jet';
    import { showConfirm } from '@amp/web-app-components/src/stores/warning';
    import { loggerFor } from '@amp/web-apps-logger/src';
    import type { DefaultAccessoryButton } from '@jet-app/music-classical/models/section/AccessoryButton';

    export let item: DefaultAccessoryButton;
    export let ariaLabel: string = null;

    const i18n = getI18n();
    const perform = getJetPerform();
    const log = loggerFor('<ClearRecentlySearched>');

    const handleClick = async () => {
        let shouldRemove = await showConfirm({
            header: $i18n.t(
                'ASE.Web.MusicClassical.Search.RecentlySearched.ConfirmClear.Header',
            ),
            message: $i18n.t(
                'ASE.Web.MusicClassical.Search.RecentlySearched.ConfirmClear.Message',
            ),
            actionText: $i18n.t(
                'ASE.Web.MusicClassical.Search.RecentlySearched.ConfirmClear.ConfirmMessage',
            ),
            confirmText: $i18n.t(
                'ASE.Web.MusicClassical.Library.PlaylistCreation.Cancel',
            ),
        });

        if (shouldRemove) {
            perform(item.segue);
        }
    };
</script>

<button
    data-testId="clear-recently-searched-button"
    class="clear-recently-searched-button"
    aria-label={ariaLabel}
    on:click={handleClick}
>
    {item.text}
</button>

<style lang="scss">
    .clear-recently-searched-button {
        display: block;
        width: 100%;
        text-align: inherit;
        color: var(--linkColor, inherit);

        &[disabled] {
            opacity: 0.7;
            cursor: default;
        }
    }
</style>
